/* @jsxImportSource react */

import type { FC } from 'react';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { unmask } from '@packages/gql/src/betterMasking';
import { ProductCardV2Price } from '@packages/modules/src/ProductCardV2/ProductCardV2.Price.client';
import type { ProductListPriceFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductListPriceFragmentFragmentDoc';

/* GraphQL */ `
  fragment ProductListPriceFragment on SearchProductPrice {
    currentPrice
    currency
    isStartPrice
    discount {
      wasMsrp
      previousPrice
      ... on AbsoluteDiscount {
        priceDifference
      }
      ... on PercentDiscount {
        discountPercentage
      }
    }
    unitPackage {
      amount
      price
      unit
    }
  }
`;

export type ProductListPriceProps = {
  styleId: string;
  maskedPrice: FragmentType<typeof ProductListPriceFragmentFragmentDoc>;
};

export const ProductListPrice: FC<ProductListPriceProps> = ({ styleId, maskedPrice }) => {
  const price = unmask<typeof ProductListPriceFragmentFragmentDoc>(maskedPrice);

  return <ProductCardV2Price id={styleId} price={price} fixedValueTextClass="text-size-h4" />;
};
